import React from 'react'

import Box from '@mui/material/Box'
import MenuBookIcon from '@mui/icons-material/MenuBook'

import MDEditor from '@uiw/react-md-editor'

import { TerminologyListStyle, TerminologyModalStyle } from '../styles'
import TerminologyViewModal from '../modals/TerminologyViewModal'
import CiteTermModal from '../modals/CiteTermModal'
import TerminologyRevisionModal from '../modals/TerminologyRevisionModal'
import ResourceList from './ResourceList'
import ViewSourcesButton from '../shared/ViewSourcesButton'
import { safeHref } from '../../utils/safeUrl'

const TerminologyList = (props) => {
    const sources = props.sources || []
    const hasLinkedSource = sources.some(s => s && safeHref(s.url))

    const secondary = (
        <>
            <Box sx={TerminologyListStyle.titleContainer}>
                <MDEditor.Markdown
                    source={props.description}
                    style={{
                        backgroundColor: 'transparent',
                        color: 'inherit',
                        fontSize: '14px'
                    }}
                />
            </Box>
        </>
    )

    return (
        <ResourceList
            Icon={MenuBookIcon}
            listStyle={TerminologyListStyle}
            modal={
                <>
                    <TerminologyViewModal {...props} />
                    <CiteTermModal
                        id={props.id}
                        term={props.term}
                        updated={props.updated}
                        buttonProps={TerminologyModalStyle.viewButton.props}
                        sx={TerminologyModalStyle.viewButton.style}
                    />
                </>
            }
            title={props.term}
            date={props.updated.split('T')[0]}
            dateLabel='Updated:'
            showButton={false}
            viewControl={hasLinkedSource
                ? ({ buttonProps, sx }) => (
                    <ViewSourcesButton sources={sources} buttonProps={buttonProps} sx={sx} />
                )
                : undefined}
            secondaryContent={secondary}
            extraActions={<TerminologyRevisionModal {...props} />}
        />
    )
}

export default TerminologyList
